import React from 'react';
import Select, { GroupBase, Props } from 'react-select';

export type { SingleValue } from 'react-select';

const formatAccessOptionLabel = (option: unknown) => {
  const label = String((option as { label?: string })?.label || '');

  return (
    <span
      title={label}
      style={{
        display: 'block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: 13,
        lineHeight: '16px',
      }}
    >
      {label}
    </span>
  );
};

const AccessSelect = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: Props<Option, IsMulti, Group>,
) => {
  const controlStyles = props.styles?.control;
  const menuPortalStyles = props.styles?.menuPortal;

  return (
    <Select
      {...props}
      menuPlacement={props.menuPlacement ?? 'auto'}
      menuPortalTarget={props.menuPortalTarget ?? (typeof document !== 'undefined' ? document.body : undefined)}
      menuShouldScrollIntoView={props.menuShouldScrollIntoView ?? false}
      styles={{
        ...props.styles,
        control: (baseStyles, state) => ({
          ...(controlStyles ? controlStyles(baseStyles, state) : baseStyles),
          background: '#0a1929',
          border: `1px solid ${state.isFocused ? '#39b3ea' : '#34516a'}`,
          color: '#c2ccd8',
        }),
        menuPortal: (baseStyles, state) => ({
          ...(menuPortalStyles ? menuPortalStyles(baseStyles, state) : baseStyles),
          zIndex: 1600,
        }),
      }}
      formatOptionLabel={props.formatOptionLabel || formatAccessOptionLabel}
    />
  );
};

export default AccessSelect;
